import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vex-custom-layout-auth',
  templateUrl: './custom-layout-auth.component.html',
  styleUrls: ['./custom-layout-auth.component.scss']
})
export class CustomLayoutAuthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
